import { createStore } from 'redux';

function hideInEX(state = {}, action){
    switch (action.type) {
        case 'hide_data':
            return Object.assign({}, state, (action['data'] ? action['data'] : {}))
        case 'exclude_data':
            return Object.assign({}, state, (action['data'] ? action['data'] : {})) 
        case 'exclude_data_recounselling':
            return Object.assign({}, state, (action['data'] ? action['data'] : {}))   
        case 'SET_NME_POPUPS_SCHEMA':
                return Object.assign({}, state, (action['data'] ? action['data'] : {}))
        case 'NME_VIEW_DATA':
                return Object.assign({}, state, (action['data'] ? action['data'] : {}))
        case 'VALIDATION_NME':
            return Object.assign({}, state, (action['data'] ? action['data'] : {}))        
        default:
            return state
    }
}

let hideInEXStore = createStore(hideInEX);

export default hideInEXStore ;
